import SearchIcon from '@jetbrains/icons/search.svg'
import List from '@jetbrains/ring-ui/components/list/list'
import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'

import {useFilter} from '../../../hooks/useFilter'
import NoAvailableRepositories from '../NoAvailableRepositories/NoAvailableRepositories'

import type {RepositoryListItem, RepositoryListProps} from './RepositoryList.types'
import useRepositoryList from './useRepositoryList'

import styles from './RepositoryList.css'

import Input, {Size} from 'src/components/pages/PipelinesPages/components/Input'

function RepositoryList({repositoryGroups, onSelect}: RepositoryListProps) {
  const {
    repositoryList,
    changeValueInputHandler,
    filterValue,
    onSelectItem,
    isAvailableRepositories,
    isRepositoryTestConnectionLoading,
  } = useRepositoryList(repositoryGroups, onSelect)
  const {
    resetActiveIndex,
    onFilterKeyPress,
    onFilterChange,
    onFilterSubmit,
    onFilterClear,
    activeIndex,
  } = useFilter<RepositoryListItem>({
    data: repositoryList,
    onSelect: onSelectItem,
    setFilterValue: changeValueInputHandler,
  })
  const selectFilterIcon = isRepositoryTestConnectionLoading ? LoaderInline : SearchIcon

  return (
    <>
      <form onSubmit={onFilterSubmit}>
        <Input
          size={Size.L}
          onChange={onFilterChange}
          onClear={onFilterClear}
          onFocus={resetActiveIndex}
          onBlur={resetActiveIndex}
          onKeyDown={onFilterKeyPress}
          label="Search or paste any GitHub URL"
          placeholder="github.com/user/repo.git"
          value={filterValue}
          autoComplete="off"
          icon={selectFilterIcon}
        />
        <span className={styles.searchInputHelpText}>
          {'Any repository accessible with your account'}
        </span>
      </form>
      {isAvailableRepositories ? (
        <List<RepositoryListItem>
          className={styles.list}
          data={repositoryList}
          onSelect={onSelectItem}
          shortcuts
          activeIndex={activeIndex}
        />
      ) : (
        <NoAvailableRepositories />
      )}
    </>
  )
}

export default RepositoryList
